import { c as _c } from "react/compiler-runtime";
import { useControlledSwr } from '@systemeio/util';
import { MAIN_API } from 'modules/main/api/main-api';
import { MainFilterInterface } from 'modules/main/types/main-filter-interface';
import { MainLeadsInterface } from 'modules/main/types/main-interface';
import { getMainFilterQuery, hasMainFilterDates } from 'modules/main/utils/get-main-filter-query';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
export function useMainLeads(filter) {
  const $ = _c(4);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== filter || $[2] !== user) {
    t1 = () => hasMainFilterDates(filter) && [`${MAIN_API}/leads?${getMainFilterQuery(filter)}`, user];
    $[1] = filter;
    $[2] = user;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return useControlledSwr(t1, fetcher, undefined, !!user);
}